/* eslint-disable no-await-in-loop */
import * as MutationTypes from './mutationTypes';
import * as api from './api';
import { ProductRecommendation } from './models';

export const productRecommendationListRequest = async ({
  commit,
  getters: { productRecommendationList }
}, pointOfSaleGuid) => {
  if (productRecommendationList.length === 0) {
    const response = await api.productRecommendationListRequest(pointOfSaleGuid);
    const list = ProductRecommendation.toInstanceList(response.data);
    commit(MutationTypes.PRODUCT_RECOMMENDATION_LIST_SUCCESS, list);
  }
};

export const createProductRecommendationRequest = async ({ commit }, productRecommendationToCreate) => {
  const response = await api.createProductRecommendationRequest(productRecommendationToCreate.serialize());
  const productRecommendation = ProductRecommendation.toInstance(response.data);
  commit(MutationTypes.CREATE_PRODUCT_RECOMMENDATION_SUCCESS, productRecommendation);
};

export const editProductRecommendationRequest = async ({ commit }, productRecommendationToEdit) => {
  const response = await api.editProductRecommendationRequest(productRecommendationToEdit.guid, productRecommendationToEdit.serialize());
  const productRecommendation = ProductRecommendation.toInstance(response.data);
  commit(MutationTypes.EDIT_PRODUCT_RECOMMENDATION_SUCCESS, productRecommendation);
};

export const removeProductRecommendationRequest = async ({ commit }, productRecommendationGuid) => {
  await api.removeProductRecommendationRequest(productRecommendationGuid);
  commit(MutationTypes.REMOVE_PRODUCT_RECOMMENDATION_SUCCESS, productRecommendationGuid);
};
